import { Component, Input, OnInit, inject } from '@angular/core';
import { AppService } from '../../../_services/app.service';

@Component({
  selector: 'manager-loader-action',
  templateUrl: './loader_action.component.html',
  standalone: false,
})
export class LoaderActionComponent implements OnInit {
  appS = inject(AppService);

  @Input() type: string;
  @Input() wrapper: string;
  //
  @Input() header: boolean;
  @Input() footer: boolean;

  ngOnInit() {}
}
